import axios from 'axios'
import router from '../router'
import store from '../store'
import { Toast } from 'mint-ui'
let env = process.env.NODE_ENV
let urls = {
  'production': '//edu.turingapi.com',
  'beta': '//edu-beta.turingapi.com',
  'alpha': '//edu-alpha.turingapi.com',
  'development': '//edu-alpha.turingapi.com'
}

const connection = axios.create({
  baseURL: urls[env],
  timeout: 60000,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})
connection.interceptors.request.use((config) => {
  if (store.state.isXTC == 1) { // eslint-disable-line
    // 小天才服务号
    config.headers.Identify = store.state.xtcOpenId.join('|') || null
  }
  config.headers.Authorization = sessionStorage.getItem('token') || null
  return config
}, (error) => {
  return Promise.reject(error)
})

connection.interceptors.response.use(function (response) {
  if (response.data.code === 401) {
    if (store.state.isXTC != 1) {// eslint-disable-line
      sessionStorage.clear()
      router.replace('/login')
      // router.replace('/share')
    }
    return {
      data: {
        code: 401
      }
    }
  }
  let URL = ['api/v1/member/common/tips/read/1', 'banner_config.json', '/api/v1/member/login/openid']
  let findVal = URL.findIndex(item => {
    return response.request.responseURL.indexOf(item) > -1
  })
  let onoff = findVal > -1
  if (response.data.code !== 200 && !onoff) {
    Toast({
      message: response.data.message,
      position: 'middle',
      duration: 1500
    })
  }
  return response
  // return Promise.resolve(response)
}, function (error) {
  if (error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          Toast({
            message: '缺少权限，请关闭页面，重新打开页面',
            position: 'middle',
            duration: 1500
          })
          return
        case 403:
          // 403 权限不足
          Toast({
            message: '缺少权限，请关闭页面，重新打开页面',
            position: 'middle',
            duration: 1500
          })
          return
      }
    }
  }
  return Promise.reject(error)
})
export default connection
